module.exports = __webpack_public_path__ + "static/media/ht.34eb5f59.svg";